import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { StockTable } from "./StockTable";
import { StockMovementChart } from "./StockMovementChart";
import { StockSummary } from "./StockSummary";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileDown } from "lucide-react";
import { exportReport } from "@/utils/exportReport";
import { toast } from "sonner";

export function StockReport() {
  const { data: stockItems, isLoading } = useQuery({
    queryKey: ["stock-items"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("stock_items")
        .select(`
          *,
          category:categories(name),
          type:types(name),
          material:materials(name),
          thickness:thicknesses(value, unit),
          dimension:dimensions(value)
        `);

      if (error) throw error;
      return data;
    },
  });

  const handleExport = async () => {
    try {
      if (!stockItems?.length) {
        toast.error("Não há dados para exportar");
        return;
      }

      const formattedData = stockItems.map(item => ({
        Categoria: item.category?.name || 'N/A',
        Tipo: item.type?.name || 'N/A',
        Material: item.material?.name || 'N/A',
        Espessura: `${item.thickness?.value || 0}${item.thickness?.unit || 'mm'}`,
        Dimensão: item.dimension?.value || 'N/A',
        Quantidade: item.quantity,
        "Quantidade Mínima": item.minimum_quantity,
        Descrição: item.description || 'N/A'
      }));

      await exportReport(formattedData, `relatorio-estoque-${new Date().toISOString().split('T')[0]}`);
      toast.success("Relatório exportado com sucesso!");
    } catch (error) {
      console.error("Erro ao exportar relatório:", error);
      toast.error("Erro ao exportar relatório");
    }
  };

  if (isLoading) {
    return <div>Carregando...</div>;
  }

  return (
    <div className="space-y-6 w-full">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <h2 className="text-2xl font-bold text-[#004080]">Relatório de Estoque</h2>
        <Button
          onClick={handleExport}
          className="bg-[#0073B7] hover:bg-[#004080] text-white w-full sm:w-auto"
        >
          <FileDown className="mr-2 h-4 w-4" />
          Exportar Relatório
        </Button>
      </div>
      
      <StockSummary data={stockItems} />
      
      <Card className="p-4 lg:p-6 bg-[#1A1F2C] border-[#404040]">
        <StockMovementChart />
      </Card>
      
      <Card className="p-4 lg:p-6 bg-[#1A1F2C] border-[#404040]">
        <StockTable data={stockItems} />
      </Card>
    </div>
  );
}